module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Bold.d6b2667f.ttf";